var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBubbleChart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 1000 1000",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M90.8,944.5c0,22.4-18.1,40.4-40.4,40.4l0,0c-22.4,0-40.4-18.1-40.4-40.4V55.5c0-22.4,18.1-40.4,40.4-40.4l0,0c22.4,0,40.4,18.1,40.4,40.4V944.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.4,984.9c-22.4,0-40.4-18.1-40.4-40.4l0,0c0-22.4,18.1-40.4,40.4-40.4h899.2c22.4,0,40.4,18.1,40.4,40.4l0,0c0,22.4-18.1,40.4-40.4,40.4H50.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M791.2,820.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M653.4,680.8c0,90.7,73.5,164.2,164.2,164.2c90.7,0,164.2-73.5,164.2-164.2s-73.5-164.2-164.2-164.2C726.9,516.7,653.4,590.2,653.4,680.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.2,416.9c0,44.5,36,80.6,80.5,80.6c44.5,0,80.6-36,80.6-80.5c0,0,0,0,0-0.1c0-44.5-36.1-80.6-80.6-80.6C208.2,336.3,172.2,372.4,172.2,416.9L172.2,416.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.7,242.6c0,22.3,18.1,40.4,40.4,40.4s40.4-18.1,40.4-40.4c0-22.3-18.1-40.4-40.4-40.4S401.7,220.3,401.7,242.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.9,640.4c0,22.3,18.1,40.4,40.4,40.4s40.4-18.1,40.4-40.4c0-22.3-18.1-40.4-40.4-40.4S320.9,618.1,320.9,640.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M640.8,332c0,32.1,26,58.1,58.1,58.1s58.1-26,58.1-58.1s-26-58.1-58.1-58.1S640.8,300,640.8,332z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M555.8,540.4c0,22.3,18.1,40.4,40.4,40.4s40.4-18.1,40.4-40.4c0-22.3-18.1-40.4-40.4-40.4S555.8,518.1,555.8,540.4z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBubbleChart);
export default __webpack_public_path__ + "static/media/bubbleChart.539f6b91696989f93ecb805dc30456f7.svg";
export { ForwardRef as ReactComponent };